import {
  APP_ACTION,
  doDataLayerEvent,
  doGAEvent,
} from '../../../utils/services/googleAnalytics'
import { displayValueDict } from './tableHeaders'

const formatEntries = (obj, labelName) => {
  const isOrdering = obj['source'] === 'EC' ? true : false

  return Object.entries(obj).reduce((result, [key, val]) => {
    // console.log(key, val)

    const myDict = displayValueDict[key]

    let displayValue = myDict && myDict[val] && myDict[val].display ? myDict[val].display : val
    if (typeof val === 'object') {
    } else if (val === undefined) {
    } else if (
      !isOrdering &&
      (key === 'injectionResinModel' ||
        key === 'pasteOverEpoxyModel' ||
        key === 'pumpingPortModel' ||
        key === 'injectionFittingModel' ||
        key === 'adhesiveAnchorModel')
    ) {
    } else if (key === 'source' || key === 'sourceDomain') {
    } else if (
      (key === 'embedmentDepth' || key === 'screenTube' || key === 'waterFilledHoles') &&
      !val
    ) {
    } else {
      result =
        result +
        ' - ' +
        key +
        ':' +
        displayValue +
        (key === 'embedmentDepth' ||
        key === 'crackDepth' ||
        key === 'crackLength' ||
        key === 'pumpingPortSpacing'
          ? '"'
          : '')
    }
    return result
  }, labelName)
}

export const handleGAEvent = ({ appEventName, gaActionName, gaLabelName, input, output }) => {
  const gaInput = Object.assign(
    {},
    input,
    {
      solutionFound:
        gaActionName === APP_ACTION.UPLOAD
          ? 'N/A'
          : output && output.msgHeader && output.msgBody
          ? 'No'
          : 'Yes',
    },
    output &&
      output.msgHeader &&
      output.msgBody && { message: output.msgHeader + '. ' + output.msgBody },
  )
  delete gaInput.validation

  const formattedGALabel = formatEntries(gaInput, gaLabelName)

  doGAEvent(appEventName, gaActionName, formattedGALabel)
}

export const handleDataLayerEvent = ({appEventName, appAction, appInputs, appOutputs }) => {
  let keyName

  if (appAction === 'AddToJobList_Action' || appAction === 'Order_Action') {
    keyName = 'outputs'
  } else if (appAction === 'Click_Link_Action') {
    keyName = 'link_text'
  } else {
    keyName = 'inputs'
  }

  const payload = Object.assign({
    app_name: appEventName,
    app_action: appAction,
    ...(appAction === 'AddToJobList_Action' ||
    appAction === 'Order_Action' ||
    appAction === 'Click_Link_Action'
      ? {}
      : {
          solution_found:
            appAction === APP_ACTION.UPLOAD
              ? 'N/A'
              : appOutputs && appOutputs.msgHeader && appOutputs.msgBody
              ? 'No'
              : 'Yes',
        }),
    [keyName]: appInputs,
  })

  doDataLayerEvent(payload)
}
